import React,{useState, useEffect} from "react";
import {
  TextField,
  Button,
  makeStyles,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  CircularProgress,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider
} from "@material-ui/core";
import {
  Dashboard
} from "@material-ui/icons";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { empIDMaxLength, numericRegex } from "config";
import { properCase } from "../utils";
import { useHistory } from "react-router-dom";
import { getWorkerDetails, updateWorkerProperty } from '../services';
import {ROOT} from '../navigation/CONSTANTS';
import { ADMIN , SUPER_USER, SUPPORT} from "../config";
import clsx from "clsx";
import DrawerFooter from './DrawerFooter';
import Alert from "@material-ui/lab/Alert";

const inputProps = {
  maxLength: empIDMaxLength
};
const drawerWidth = 270;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
  },
  dialogContent: {
    paddingLeft: 35,
  },
  outerContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
   // alignItems: "center",
    minHeight: 120,
  },
  innerContainer: {
    display: "flex",
    flexDirection: "row",
   // justifyContent: "center",
    alignItems: "center",
    width:'50%'
  },
  cardTitle: {
   // color: theme.palette.primary.main,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    fontWeight:'bold'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  paperStyle: {
    top: "unset",
    height: `calc(100% - 100px)`,
    border: "none",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    overflow: "auto",
  },
  list: {
    width: "100%",
    maxWidth: 360,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
  },
}));

const UndeleteWorker = () =>{

  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const { isLoading, userRole, error:userRoleError } = useSelector(
    (state) => state.user.imtRole
  );
  const appConfig = useSelector((state) => state.appConfig);
  const { dscDrawerOpen } = appConfig;
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [empId, setEmpId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [openConfirmationMessage, setOpenConfirmationMessage] = useState(false);
  const [confirmationMsgText, setConfirmationMsgText] = useState('');

  useEffect(() =>{
    if(userRole && Object.keys(userRole).length > 0){
      if(userRole.role !== ADMIN && userRole.role !== SUPER_USER && userRole.role !== SUPPORT ){
        history.push(ROOT);
      }
    }
  },[userRole, userRoleError])

  const closeModalConfirmationMsg = () =>{
    setEmpId("");
    setDisableSubmit(true);
    setOpenConfirmationMessage(false);
    setConfirmationMsgText("");
  }

  const submitHandler = async (event) =>{
    event.preventDefault();
    setError("");
    setLoading(true);
    setDisableSubmit(true);
    try{
      getWorkerDetails(empId).then(workerDoc => {
      if(!workerDoc.exists){
        console.log("No Doc found for ", empId);
        setError("Worker is not found");
        setDisableSubmit(false);
        setLoading(false);
      }else{
              let workerDetails = {...workerDoc.data()};
              console.log("workerDetails", workerDetails);
              if(workerDetails && workerDetails.workerType && workerDetails.workerType == 'temp'){
                  if(workerDetails && !workerDetails.isActiveWorker){
                    if(workerDetails.isDeleted){
                    let updatedWorkerProperties={
                      isActiveWorker:true,
                      isDeleted:false
                    }
                    updateWorkerProperty( empId, updatedWorkerProperties).then(data =>{
                      if(data){
                        setConfirmationMsgText(`${empId} undeleted successfull`);
                        setOpenConfirmationMessage(true);
                        setError("");
                        setLoading(false);
                      }else{
                        console.log("error in undeleting worker");
                        setError("worker Details not found")
                        setDisableSubmit(false);
                        setLoading(false);
                      }
                    }).catch(err =>{
                      console.log("error in undeleting worker");
                        setError(err)
                        setDisableSubmit(false);
                        setLoading(false);
                    })
                  }else{
                    console.log("worker is inactive but not deleted", empId);
                    setError("Worker is inactive but not deleted");
                    setDisableSubmit(false);
                    setLoading(false);
                  }
                }else{
                  console.log("worker is active and not deleted", empId);
                    setError("worker is active and not deleted");
                    setDisableSubmit(false);
                    setLoading(false);
                }
              }else{
                console.log("worker is not Temp worker", empId);
                    setError("worker is not Temp worker");
                    setDisableSubmit(false);
                    setLoading(false);
              }
            }
    });
    
    }catch(err){
      console.log("error in undeleting the worker", err);
      setError(err);
      setLoading(false);
    }
  }

  const onEmployeeIdChange = (event) =>{
    event.preventDefault();
    setError("");
    if(numericRegex.test(event.target.value)){
    if (event.target.value === "") {
      setDisableSubmit(true);
    } else {
      setDisableSubmit(false);
    }
    setEmpId(event.target.value);
    }
  }

  return(
    <div className={classes.root}>
    <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: dscDrawerOpen,
            [classes.drawerClose]: !dscDrawerOpen,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: dscDrawerOpen,
              [classes.drawerClose]: !dscDrawerOpen,
            }),
          }}
          PaperProps={{ className: classes.paperStyle }}
        >
          <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        className={classes.list}
      >
        <ListItem
          button
        // selected={selectedIndex === 0}
          onClick={() => history.push(ROOT)}
        >
          <ListItemIcon>
            <Dashboard />
          </ListItemIcon>
          <ListItemText
          style={{color:"black"}}
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("pgReview.tlDashboard"))}
          />
        </ListItem>
        <Divider />
        </List>
        <DrawerFooter />
      </Drawer>
      <main className={classes.content}>
    {isLoading ? <>
        <CircularProgress />
    </> : userRoleError || !userRole || !userRole.role || (userRole.role !== ADMIN && userRole.role !== SUPER_USER && userRole.role !== SUPPORT)? 
          <>
          <Alert severity="info">{userRoleError}. Restrcited Access.</Alert>
          </>
    :
        <form noValidate autoComplete="off" onSubmit={submitHandler}>
          <Box className={classes.outerContainer}>
          <Box style={{width:'50%'}}>
              <Typography
                noWrap
                variant="subtitle1"
                component="h2"
                className={classes.cardTitle}
              >
                Undelete Worker
              </Typography>
              </Box>
            <Box className={classes.innerContainer}>
              <Box>
                <TextField
                  label={t("pgHome.phEmpId")}
                  autoFocus
                  required
                  variant="outlined"
                  value={empId}
                  placeholder={t("pgHome.phEmpId")}
                  onChange={onEmployeeIdChange}
                  error={error ? true : false}
                  helperText={
                    error
                      ? t(error)
                      : loading
                      ? properCase(t("pgHome.loadingWorker"))
                      : ""
                  }
                  inputProps={inputProps}
                  size="small"
                />
              </Box>

              <Box pl={4}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={disableSubmit}
                //  isLoading={loading}
                >
                  {properCase(t("pgHome.btEmpId"))}
                </Button>
              </Box>
            </Box>
          </Box>
        </form>
        }
        <Dialog
        open={openConfirmationMessage}
        onClose={closeModalConfirmationMsg}
        aria-labelledby="confirmation-dialog"
        disableBackdropClick
      >
        <DialogTitle id="form-dialog-title">
          {"Confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{confirmationMsgText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModalConfirmationMsg} color="primary">
            {t("pgPunch.btnOK")}
          </Button>
        </DialogActions>
      </Dialog>
      </main>
    </div>
  )
}

export default UndeleteWorker;